import StyledToastContainer from '@components/shared/toaster/toaster';
import { UserManager } from 'oidc-client-ts';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from 'styled-components';
import { AuthProvider } from './AuthProvider';
import { store } from './store/AppState';
import { theme } from './styles/theme';

export function Providers({
  userManager,
  children,
}: {
  userManager: UserManager;
  children: React.ReactElement;
}) {
  const queryClient = new QueryClient();

  return (
    <>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <ReduxProvider store={store}>
              <AuthProvider userManager={userManager}>{children}</AuthProvider>
            </ReduxProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
      <StyledToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName='toast-container'
        closeButton={false}
      />
    </>
  );
}
